import { motion, useInView, Variants } from 'framer-motion';
import React, { useRef, ReactNode } from 'react';

interface ScrollAnimatedSectionProps {
  children: ReactNode;
  variants: Variants;
  className?: string;
  viewAmount?: number;
  once?: boolean;
  delay?: number;
}

/**
 * @param children - The content to be animated
 * @param variants - Framer Motion animation variants
 * @param className - Optional CSS class name
 * @param viewAmount - Amount of element that needs to be in view to trigger animation (0-1), default: 0.2
 * @param once - Whether the animation should only play once, default: true
 * @param delay - Optional delay before animation starts after coming into view (in seconds)
 */
const ScrollAnimatedSection: React.FC<ScrollAnimatedSectionProps> = ({
  children,
  variants,
  className = '',
  viewAmount = 0.5,
  once = true,
  delay = 0
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once, amount: viewAmount });
  
  return (
    <motion.div
      ref={ref}
      className={className}
      variants={variants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      transition={{ delay }}
    >
      {children}
    </motion.div>
  );
};

export default ScrollAnimatedSection; 